module.exports = __webpack_public_path__ + "static/mood-board-app-tablet-plp-6261d06ab4d21a93ae7732bd9248f121.png";